import React, {useState} from 'react';
import ImageLoader from 'src/legacy/components/ImageLoader';
import LoadingDots from 'src/legacy/components/LoadingDots';
import Measure from 'react-measure';

import _ from "lodash";
import cx from "classnames";
import styles from "./tooltip.module.scss";

interface CustomTooltipProps {
    iconDimensions: {
      width: number;
      height: number;
    };
    timeSpentLabel: string;
    activePage: any;
    preview: any;
    className?: string;
  }
  
  const CustomTooltip = ({
    iconDimensions,
    timeSpentLabel,
    activePage,
    preview,
    className
  }: CustomTooltipProps) => {
    const [bounds, setBounds] = useState({
      width: 170,
      height: 190,
    });
  
    const calculatePosition = () => {
      if(activePage) {
      const { y } = activePage;    
      return {
        top: - bounds.height + (y - 10),
      };
    }
    };
  
    const padNumber = (number = 0, pad: any) => {
      number = Math.ceil(number);
  
      const length = pad - String(number).length + 1;
      let padding = "";
      if (length > 0) {
        padding = Array(pad - String(number).length + 1).join("0");
      }
      return padding + number;
    };
  
    let image = null;
    const width = iconDimensions.width;
    let height = iconDimensions.height;
  
    const loadingPreview = _.get(preview,"loading",false);
  
    if (
      preview && preview.item && activePage &&
      !loadingPreview &&
      preview.item.pages &&
      activePage.index
    ) {
      
      const page = preview.item.pages[activePage.index - 1];
      image = _.get(page, "background.thumbnail");
  
      height = (_.get(page, "height") / _.get(page, "width")) * width;
      height = Math.min(height, iconDimensions.height);
    }
  
    const position = calculatePosition();
  
    const timeSpent = activePage?.avgTimeSpent || 0;
    const minutes = padNumber(Math.floor(timeSpent / 60), 2);
    const seconds = padNumber(timeSpent % 60, 2);
    const pageNumber = padNumber(activePage?.index, 2);
  
    return (
      <Measure
        bounds
        onResize={(contentRect) => {
          setBounds(contentRect.bounds);
        }}
      >
        {({ measureRef }) => (
          <div
            className={cx(styles.tooltip, className)}
            id="page_tooltip"
            style={position}
            ref={measureRef}
          >
            <div
              className={styles.icon}
              style={{ width: width, height: height }}
            >
              {loadingPreview && <LoadingDots dotSize={8} />}

              {!loadingPreview && (
                <ImageLoader
                  src={image}
                  imgProps={{
                    className: styles.previewIcon,
                    width: width,
                    height: height,
                  }}
                  preloader={() => <LoadingDots dotSize={8} />}
                />
              )}
            </div>
            <div className={cx(styles.metadata, "CustomTooltipView--metadata")}>
              <span className={styles.page}>
                #<span className={styles.numbers}>{pageNumber}</span>
              </span>
              <span className={styles.separator}></span>
              <span className={styles.timeSpent}>
                {timeSpentLabel}{" "}
                <span
                  className={styles.numbers}
                >{`${minutes}:${seconds}`}</span>
              </span>
            </div>
          </div>
        )}
      </Measure>
    );
  };

export default CustomTooltip;